import { useState, type FC } from 'react';
import styles from './Mfa.module.scss';
import CopyIcon from './assets/copy.svg?react';

interface Props {
  value: string;
  testId?: string;
}

/** Copies `value` to the clipboard and briefly confirms. Used for the TOTP manual-entry key. */
export const CopyButton: FC<Props> = ({ value, testId }) => {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard?.writeText(value);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard access can be denied (insecure context / permissions); the manual key stays
      // visible for the user to copy by hand, so there is nothing to surface here.
    }
  };

  return (
    <button type="button" className={styles.copyButton} onClick={copy} data-testid={testId}>
      <CopyIcon />
      {copied ? 'Copied' : 'Copy'}
    </button>
  );
};
